import payload_plugin_qLmFnukI99 from "/vercel/path0/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/vercel/path0/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/vercel/path0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/vercel/path0/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/vercel/path0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/vercel/path0/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/vercel/path0/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_immediate_client_xfI97IMoyr from "/vercel/path0/node_modules/nuxt/dist/app/plugins/chunk-reload-immediate.client.js";
import plugin_vue3_YdLad5Mpq3 from "/vercel/path0/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/vercel/path0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_config_o34nk2sJbg from "/vercel/path0/.nuxt/sentry-client-config.mjs";
import plugin_client_UYiXMU8ZyN from "/vercel/path0/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import axios_QMFgzss1s4 from "/vercel/path0/plugins/axios.ts";
import draggableScroll_S42bquejQE from "/vercel/path0/plugins/draggableScroll.ts";
import auto_title_directive_CdVKNuXfwg from "/vercel/path0/plugins/auto-title-directive.ts";
import longpress_client_fkh16IUsaS from "/vercel/path0/plugins/longpress.client.ts";
import mitt_S0QU5gJPTl from "/vercel/path0/plugins/mitt.ts";
import persistedstate_client_O5MsxXlNtZ from "/vercel/path0/plugins/persistedstate.client.ts";
import safari_scroll_fix_client_YYNMdR3Z6v from "/vercel/path0/plugins/safari-scroll-fix.client.ts";
import vue3_lazyload_client_sN7eAyLYUi from "/vercel/path0/plugins/vue3-lazyload.client.ts";
import vue3_lottie_client_xXNcInN2H5 from "/vercel/path0/plugins/vue3-lottie.client.ts";
import vue3_touch_events_3JrctwDJKG from "/vercel/path0/plugins/vue3-touch-events.ts";
import sentry_client_VdOeuw25Mb from "/vercel/path0/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_immediate_client_xfI97IMoyr,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_config_o34nk2sJbg,
  plugin_client_UYiXMU8ZyN,
  axios_QMFgzss1s4,
  draggableScroll_S42bquejQE,
  auto_title_directive_CdVKNuXfwg,
  longpress_client_fkh16IUsaS,
  mitt_S0QU5gJPTl,
  persistedstate_client_O5MsxXlNtZ,
  safari_scroll_fix_client_YYNMdR3Z6v,
  vue3_lazyload_client_sN7eAyLYUi,
  vue3_lottie_client_xXNcInN2H5,
  vue3_touch_events_3JrctwDJKG,
  sentry_client_VdOeuw25Mb
]